import { CSSObject } from '@emotion/core';

export const containerStyles: CSSObject = {
    padding: '16px 24px',
};
